export default __webpack_public_path__ + "static/tennentsLogo-ffba53f5af547e7683796d1d78668ce4.png";